
import {createSlice} from '@reduxjs/toolkit'
import { fetchpaytype } from '../../action/master/paytypeAction'

interface paytypeState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: paytypeState = {
  data: null,
  status: 'idle',
  error: null,
}

const paytypeSlice = createSlice({
  name: 'paytype',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchpaytype.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchpaytype.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchpaytype.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default paytypeSlice.reducer
